import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';

export const ORIGIN =
  typeof window !== 'undefined'
    ? window.location.origin // Client-side
    : 'http://localhost:8080'; // Server-side

export const httpLink = new HttpLink({
  uri: `${ORIGIN}/api/graphql`,
});

export const wsClient = new GraphQLWsLink(
  createClient({
    url: `${ORIGIN.replace('http', 'ws')}/api/graphql/subscriptions`,
  }),
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsClient,
  httpLink,
);

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
